
import { Conversation } from "@/types/conversation";
import { DBMessage } from "@/types/message";
import { Dispatch, SetStateAction } from "react";
import { useToast } from "@/hooks/use-toast";

export const useMessageGeneration = (id: string | undefined) => {
  const { toast } = useToast();

  const generateResponse = async (
    conversation: Conversation | null,
    messages: DBMessage[],
    sellerResponseContent: string | undefined,
    setMessages: Dispatch<SetStateAction<DBMessage[]>>,
    handleGenerateResponse: (
      conversation: Conversation, 
      messages: DBMessage[], 
      sellerResponseContent?: string
    ) => Promise<DBMessage | null>
  ) => {
    if (!conversation) {
      console.error("Cannot generate response: conversation is null");
      toast({
        variant: "destructive",
        title: "Error",
        description: "Unable to generate a response because the conversation could not be loaded."
      });
      return null;
    }
    
    const newMessage = await handleGenerateResponse(conversation, messages, sellerResponseContent);
    if (newMessage) {
      setMessages(prev => [...prev, newMessage]);
    }
    return newMessage;
  };

  return { generateResponse };
};
